import { gql } from '@apollo/client';

import { CampaignMetadata } from './types';

export const USE_CAMPAIGN_HOOK_QUERY = gql`
  query CampaignQuery($id: Long!) {
    campaign(id: $id) {
      id
      name
    }
  }
`;

export const USE_CAMPAIGNS_HOOK_QUERY = gql`
  query CampaignsQuery(
    $search: String
    $ids: [Long!]
    $pagination: Pagination!
    $sort: Sort!
    $campaignFilterInfo: CampaignFilterInfoInput
  ) {
    campaigns(
      search: $search
      pagination: $pagination
      sort: $sort
      ids: $ids
      campaignFilterInfo: $campaignFilterInfo
    ) {
      info {
        count
      }
      results {
        id
        name
        templateId
        expectedSendSize
      }
    }
  }
`;

export const DEFAULT_CAMPAIGNS: CampaignMetadata[] = [];
